import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Modal } from "@ts-digital/vrc";
import { Input, Select } from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { multipleLinkFulfilmentToCustomer } from "../../../store/actions/fulfilments/links";
import { getBackofficeFulfilmentCustomers } from "../../../store/actions/fulfilments/customers";
import LoaderSimple from "../../general/loader";
import VaporChip from "../../vapor/chip";
import FulfilmentCreateCompanies from "./companies";
import FormCreateFulfilment from "./form";
import FulfilmentCreateFulfilments from "./fulfilments";
import "./style.css";
import { displayWarningToast } from "../../../store/actions/overflowNotification";

const Option = Select.Option;

const FulfilmentCreateDialog = (props) => {
  const { editMode, customerId, fulfilmentId, month, onClose, visible } = props;

  const fulfilments = useSelector((state) => state.fulfilments);

  const auth = useSelector((state) => state.auth);
  const company = useSelector((state) => state.company);
  const main = useSelector((state) => state.main);

  const dispatch = useDispatch();

  const [activeChip, setActiveChip] = useState("all");
  const [selectedCompanies, setSelectedCompanies] = useState([]);
  const [selected, setSelected] = useState([]);
  const [manualMode, setManualMode] = useState(false);
  const [fulfilmentData, setFulfilmentData] = useState({
    type: null,
    name: "",
    deadline: moment(month + "01"),
  });
  const [showSavingSpinner, setShowSavingSpinner] = useState(false);
  const [editedThings, setEditedThings] = useState({});

  useEffect(() => {
    if (visible && fulfilmentId) {
      dispatch(getBackofficeFulfilmentCustomers(auth, fulfilmentId, main.accountantUuidSelected, main.companyUuidSelected));
    }
  }, [visible]);

  useEffect(() => {
    setSelectedCompanies([]);
    if (selected.length > 0) {
      dispatch(getBackofficeFulfilmentCustomers(auth, selected[0], main.accountantUuidSelected, main.companyUuidSelected));
    }
  }, [selected]);

  useEffect(() => {
    if (fulfilments.fulfilmentCustomers && fulfilmentId) {
      let tmpCompanyToSelect = [];
      fulfilments.fulfilmentCustomers.map((it) => {
        return tmpCompanyToSelect.push(it.customerId);
      });
      setSelectedCompanies(tmpCompanyToSelect);
    }
    if (fulfilments.fulfilmentCustomers && customerId) {
      setSelectedCompanies([customerId]);
    }
  }, [fulfilments.fulfilmentCustomers]);

  useEffect(() => {
    if (!manualMode) {
      let actionsToDo = calcActionsToLinkUnlink(!editMode);
      let tmpEditedThings = { ...editedThings };
      if (actionsToDo.length > 0) {
        setEditedThings({ ...tmpEditedThings, selectedCompanies: true });
      } else {
        delete tmpEditedThings.selectedCompanies;
        setEditedThings({ ...tmpEditedThings });
      }
    }
  }, [selectedCompanies]);

  const calcActionsToLinkUnlink = (isAdding) => {
    let actionsToDo = [];
    if (isAdding) {
      selectedCompanies.map((customerId) => {
        actionsToDo.push({ type: "link", customerId: customerId });
        return null;
      });
      return actionsToDo;
    }
    // Modifica adempimento
    selectedCompanies.map((customerId) => {
      let companyFind = fulfilments.fulfilmentCustomers.find((x) => x.customerId === customerId);
      if (!companyFind) {
        actionsToDo.push({ type: "link", customerId: customerId });
      }
      return null;
    });
    fulfilments.fulfilmentCustomers.map((customer) => {
      if (selectedCompanies.indexOf(customer.customerId) === -1) {
        actionsToDo.push({ type: "unlink", customerId: customer.customerId });
      }
      return null;
    });
    return actionsToDo;
  };

  const onConfirm = () => {
    if (!manualMode) {
      let actionsToDo = calcActionsToLinkUnlink(!editMode);
      setShowSavingSpinner(true);
      dispatch(
        multipleLinkFulfilmentToCustomer(auth, main.accountantUuidSelected, main.companyUuidSelected, editMode ? fulfilmentId : selected[0], actionsToDo)
      )
        .then((res) => {
          setShowSavingSpinner(false);
          onClose(true);
        })
        .catch((err) => {
          setShowSavingSpinner(false);
          onClose(true);
          dispatch(displayWarningToast("Errore durante la configurazione dell'adempimento"));
        });
    }
  };

  const handleCompanyClick = (companyId) => {
    let newCompanies = [...selectedCompanies];
    if (newCompanies.indexOf(companyId) > -1) {
      newCompanies.splice(newCompanies.indexOf(companyId), 1);
    } else {
      newCompanies.push(companyId);
    }
    setSelectedCompanies(newCompanies);
  };

  const handleAllCompaniesClick = (companyId) => {
    let newCompanies = [];
    if (company.companies) {
      company.companies.map((it) => {
        return newCompanies.push(it.uuid);
      });
    }
    setSelectedCompanies(newCompanies);
  };

  const onChangeSelected = (val) => {
    let newSelected = [val];
    setSelected(newSelected);
  };

  return (
    <Modal
      title={editMode ? <FormattedMessage id="fulfilments.editDialog" /> : <FormattedMessage id="fulfilments.list.addButton" />}
      visible={visible}
      onClose={() => onClose(false)}
      outsideClosable={false}
      footer={
        !showSavingSpinner &&
        !fulfilments.isGettingFulfilmentsPreset &&
        !fulfilments.isGettingFulfilmentCustomers && (
          <div className="fulfilment-create-dialog-footer">
            <Button onClick={() => onClose(false)} kind={"secondary"}>
              <FormattedMessage id="generic.cancel" />
            </Button>
            <Button onClick={onConfirm} disabled={Object.keys(editedThings).length === 0 || (customerId && selected.length === 0)}>
              {editMode ? <FormattedMessage id="actions.confirm" /> : <FormattedMessage id="actions.add" />}
            </Button>
          </div>
        )
      }
    >
      {!showSavingSpinner && !fulfilments.isGettingFulfilmentsPreset && !fulfilments.isGettingFulfilmentCustomers ? (
        <div className={"fulfilment-create-dialog-root" + (editMode ? " editMode" : "") + (customerId ? " customerPage" : "")}>
          <div className="fulfilment-create-dialog-container">
            <div className="fulfilment-create-dialog-left">
              <div className="fulfilment-create-dialog-side-title">
                {manualMode ? (
                  <div className="fulfilment-create-dialog-header-backTo">
                    <FontAwesomeIcon icon={["far", "arrow-left"]} onClick={() => setManualMode(false)} />{" "}
                    <FormattedMessage id="fulfilments.create.titleLeftManual" />
                  </div>
                ) : (
                  <FormattedMessage id="fulfilments.create.titleLeft" />
                )}
              </div>
              {!manualMode && (
                <div className="fulfilment-create-dialog-side-filter">
                  <div className="fulfilment-create-dialog-side-filter-chips">
                    {["all", "accounting", "fiscals", "management"].map((kind, index) => {
                      return (
                        <VaporChip
                          key={`vaporChip_${index}`}
                          onClick={() => setActiveChip(kind)}
                          title={useIntl().formatMessage({ id: "fulfilments.create.filters.kinds." + kind })}
                          active={activeChip === kind}
                        />
                      );
                    })}
                  </div>
                </div>
              )}
              <div className={"fulfilment-create-dialog-side-body" + (manualMode ? " manualMode" : "")}>
                {!manualMode ? (
                  <FulfilmentCreateFulfilments onChangeSelected={onChangeSelected} selected={selected} />
                ) : (
                  <FormCreateFulfilment fulfilmentData={fulfilmentData} setFulfilmentData={setFulfilmentData} />
                )}
              </div>
              {!manualMode && (
                <div className="fulfilment-create-dialog-side-footer">
                  <Button kind="tertiary" onClick={() => setManualMode(true)}>
                    <FontAwesomeIcon icon={["far", "plus"]} /> Aggiungi adempimento personalizzato
                  </Button>
                </div>
              )}
            </div>
            {!customerId && (
              <div className="fulfilment-create-dialog-right">
                {editMode || manualMode || (!manualMode && selected.length > 0) ? (
                  <div className="fulfilment-create-dialog-side-title">
                    <FormattedMessage id="fulfilments.create.titleRight" />
                    <Select allowClear placeholder="Ordina per" optionLabelProp="label">
                      <Option
                        value="az"
                        label={
                          <div className="fulfilment-create-dialog-label-order">
                            <strong>Ordina per</strong> A-Z
                          </div>
                        }
                      >
                        A-Z
                      </Option>
                      <Option
                        value="za"
                        label={
                          <div className="fulfilment-create-dialog-label-order">
                            <strong>Ordina per</strong> Z-A
                          </div>
                        }
                      >
                        Z-A
                      </Option>
                    </Select>
                  </div>
                ) : null}
                {editMode || manualMode || (!manualMode && selected.length > 0) ? (
                  <div className="fulfilment-create-dialog-side-filter right">
                    <div className="fulfilment-create-dialog-side-filter-row">
                      <Select allowClear placeholder="Natura giuridica">
                        <Option value="spa">SPA</Option>
                      </Select>
                    </div>
                    <div className="fulfilment-create-dialog-side-filter-row">
                      <Select allowClear placeholder="Tipologia cliente">
                        <Option value="spa">SPA</Option>
                      </Select>
                      <Input
                        allowClear
                        placeholder="Codice Ateco"
                        suffix={
                          <Button>
                            <FontAwesomeIcon icon={["far", "search"]} />
                          </Button>
                        }
                      />
                    </div>
                  </div>
                ) : null}
                <div className="fulfilment-create-dialog-side-body">
                  {(editMode || manualMode || (!manualMode && selected.length > 0)) && !fulfilments.isGettingBackofficeCustomers ? (
                    <FulfilmentCreateCompanies
                      handleCompanyClick={handleCompanyClick}
                      handleAllCompaniesClick={handleAllCompaniesClick}
                      selectedCompanies={selectedCompanies}
                      fulfilmentId={fulfilmentId}
                    />
                  ) : fulfilments.isGettingBackofficeCustomers ? (
                    <div className="fulfilment-create-dialog-company-loading">
                      <LoaderSimple />
                    </div>
                  ) : (
                    <div className="fulfilment-create-dialog-message-noSelected">Seleziona un adempimento dall'elenco</div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      ) : (
        <div className={"fulfilments-create-dialog-spinner" + (editMode ? " editMode" : "")}>
          <LoaderSimple message={showSavingSpinner ? "Salvataggio dati..." : "Caricamento dati..."} />
        </div>
      )}
    </Modal>
  );
};

export default FulfilmentCreateDialog;
